import React from 'react';
import { Send, Users } from 'lucide-react';

interface ConfirmBroadcastModalProps {
  isOpen: boolean;
  recipientCount: {
    users: number;
    supportUsers: number;
    total: number;
  };
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmBroadcastModal({ isOpen, recipientCount, onConfirm, onCancel }: ConfirmBroadcastModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
              <Send className="w-5 h-5 text-blue-600" />
            </div>
            <h2 className="text-lg font-bold text-[#231F20]">
              Broadcast Versturen
            </h2>
          </div>

          <p className="text-gray-600 text-sm mb-4">
            Je staat op het punt om een broadcast te versturen naar <strong>alle gebruikers</strong> in het systeem.
          </p>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <div className="flex items-center gap-2 mb-3">
              <Users className="w-4 h-4 text-blue-600" />
              <span className="font-semibold text-gray-900 text-sm">Ontvangers</span>
            </div>
            <div className="space-y-2">
              <div className="flex justify-between text-sm">
                <span className="text-gray-700">Reguliere gebruikers:</span>
                <span className="font-medium text-gray-900">{recipientCount.users}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-gray-700">Support users:</span>
                <span className="font-medium text-gray-900">{recipientCount.supportUsers}</span>
              </div>
              <div className="border-t border-blue-300 my-2"></div>
              <div className="flex justify-between">
                <span className="font-semibold text-gray-900">Totaal:</span>
                <span className="font-bold text-blue-600">{recipientCount.total}</span>
              </div>
            </div>
          </div>

          <p className="text-sm text-gray-600 mb-6">
            Weet je zeker dat je deze broadcast wilt versturen?
          </p>

          <div className="flex items-center justify-end gap-3">
            <button
              onClick={onCancel}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Annuleren
            </button>
            <button
              onClick={onConfirm}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2"
            >
              <Send className="w-4 h-4" />
              Ja, Versturen
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
